import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"measured-mtbf"},[(_vm.text)?_c('span',{staticClass:"mtbf-value"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),(_vm.icon)?_c(VIcon,{attrs:{"color":_vm.iconColor,"small":""}},[_vm._v(_vm._s(_vm.icon))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }